export const ResetIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.07307 3.38628C6.65307 3.21294 7.29307 3.09961 7.99974 3.09961C11.1931 3.09961 13.7797 5.68628 13.7797 8.87962C13.7797 12.073 11.1931 14.6596 7.99974 14.6596C4.8064 14.6596 2.21973 12.073 2.21973 8.87962C2.21973 7.69295 2.57973 6.58628 3.19306 5.66628"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.24707 3.54634L7.17374 1.33301"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.24707 3.54688L7.49374 5.18688"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
